"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoverDriversUnion = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var CardRequirements_1 = require("../CardRequirements");
var RoverDriversUnion = (function (_super) {
    __extends(RoverDriversUnion, _super);
    function RoverDriversUnion() {
        return _super.call(this, {
            name: CardName_1.CardName.ROVER_DRIVERS_UNION,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON],
            cost: 16,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.logisticRate(2); }),
            metadata: {
                description: 'Requires 2 Logistic Rate. Raise the Logistic Rate 1 step. Increase your M€ production 1 step per Logistic Rate.',
                cardNumber: 'M78',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.moonLogisticsRate().br;
                    b.production(function (pb) { return pb.megacredits(1); }).slash().moonLogisticsRate();
                }),
            },
        }) || this;
    }
    ;
    RoverDriversUnion.prototype.play = function (player) {
        MoonExpansion_1.MoonExpansion.ifMoon(player.game, function (moonData) {
            MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
            player.addProduction(Resources_1.Resources.MEGACREDITS, moonData.logisticRate, { log: true });
        });
        return undefined;
    };
    return RoverDriversUnion;
}(Card_1.Card));
exports.RoverDriversUnion = RoverDriversUnion;
//# sourceMappingURL=RoverDriversUnion.js.map